import { INITIALISE_MENU, SET_LAST_VALID_USER_SESSION, SUCCESS } from '@reduxLocal/actions/types';
import { buildDispatchData } from '@api/utils';
import { computeSessionExpireAt } from '@utils/sessionConstants';
import {
  persistAuthSession,
  saveRememberMePreference,
} from '@utils/persistentSessionStorage';
import { markRecentAuthSuccess } from '@utils/authGracePeriod';

export type PasskeyLoginResult = {
  success?: boolean;
  data?: Record<string, unknown> & {
    userData?: { id?: string };
  };
};

/**
 * Complete a successful passkey authentication — mirrors password login persistence.
 */
export async function completePasskeyLogin(
  dispatch: (action: unknown) => void,
  result: PasskeyLoginResult
): Promise<Record<string, unknown>> {
  if (!result?.success || !result?.data) {
    throw new Error('Invalid passkey login response');
  }

  const amendedData = {
    ...result.data,
    success: true,
    rememberMe: true,
    expireAt: computeSessionExpireAt(true),
  };

  saveRememberMePreference(true);
  await persistAuthSession({
    rememberMe: true,
    userId: amendedData?.userData?.id,
    sessionData: amendedData,
  });

  dispatch(buildDispatchData(SUCCESS, amendedData));
  dispatch({ type: SET_LAST_VALID_USER_SESSION, payload: amendedData });
  dispatch({ type: INITIALISE_MENU });
  markRecentAuthSuccess();

  return amendedData;
}

export function getPasskeyUserId(result: PasskeyLoginResult): string | undefined {
  const data = result?.data;
  if (!data) return undefined;
  return (
    (data.userData as { id?: string } | undefined)?.id ||
    (data as { id?: string }).id
  );
}
